import { isEmpty, size } from "lodash";
import { useSelector } from "react-redux";

import SubmittedFinancingRequestsRenderer from "../../components/renderers/SubmittedFinancingRequestsRenderer";
import DashboardSection from "./shared/DashboardSection";

const SubmittedFinancingRequestsSection = ({ mt = 8 }) => {
  const financingRequests = useSelector((state) => state?.financingRequests);

  return (
    <DashboardSection
      mt={mt}
      label={`Active Financing Requests (${size(financingRequests)})`}
    >
      <SubmittedFinancingRequestsRenderer
        financingRequests={financingRequests}
      />
    </DashboardSection>
  );
};

export default SubmittedFinancingRequestsSection;
